<template>
  <div>
    <van-nav-bar
      :title="generateCustomizeString('customerSearch')"
      :left-text="generateCustomizeString('goBack')"
      left-arrow
      @click-left="onClickLeft"
    >
      <!-- <van-icon name="aim" slot="right" /> -->
    </van-nav-bar>
    <van-search
      v-model="searchKey"
      :placeholder="generateCustomizeString('customerPlaceHolder')"
      show-action
      @search="onSearch"
    >
      <div slot="action" @click="onSearch">{{generateCustomizeString('search')}}</div>
    </van-search>
    <customer-list :isSearch="true" ref="customerList"></customer-list>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import {
  Field,
  Cell,
  CellGroup,
  Row,
  Col,
  Button,
  Search,
  NavBar,
  Icon
} from 'vant'
import CustomerList from '@/views/customers/components/CustomerList'

export default {
  name: 'CustomersSearch',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Search.name]: Search,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    CustomerList
  },
  data() {
    return {
      searchKey: ''
    }
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.go(-1)
    },
    onSearch() {
      this.$refs.customerList.fetchDataUseKeyword(this.searchKey)
    }
  },
  created: function() {
    // wxConfig.config()
  },
  mounted: function() {
    if (this.$route.params.searchKey) {
      this.searchKey = this.$route.params.searchKey
      this.$refs.customerList.fetchDataUseKeyword(this.searchKey)
    }
  }
}
</script>

<style scoped>
</style>
<style type="text/css">
.van-field__control {
  line-height: 24px !important;
}
</style>
